import { SystemLoadView } from 'protocol/api/core/svc_adminka_pb';
import { LoadLevel } from 'protocol/model/dto_system_load_pb';

import { emptySettings, sourceKeys, SystemLoadSettings } from '../config';

export const settingsFromView = (view: SystemLoadView): SystemLoadSettings =>
  sourceKeys.reduce(
    (settings, sourceKey) => ({
      ...settings,
      [sourceKey]: {
        enabled: view[sourceKey]?.Enabled ?? true,
        manual: view[sourceKey]?.Manual ?? LoadLevel.LoadLevel_InvalidValue,
        medium: Number(view[sourceKey]?.Thresholds?.Medium ?? 0),
        high: Number(view[sourceKey]?.Thresholds?.High ?? 0),
      },
    }),
    emptySettings,
  );
